import React from "react";
import { graphql, Link } from "gatsby";
import Img from "gatsby-image";
import Layout from "../components/layout/Layout";
import Article from "../components/layout/Article";
import BlogPostCard from "../components/BlogPostCard";

const PostsPage = ({ data, pageContext: { title } }) => {
  const breadcrumbs = [
    { title: "Home", path: `/`, active: false },
    { title: "Posts", path: `/blog`, active: true },
  ];
  const { edges } = data.allMdx;
  return (
    <Layout
      breadcrumbs={breadcrumbs}
      sidebar={{ recentPosts: true, search: true }}
    >
      <Article title={title}>
        <ul style={{ margin: 0 }} className="divide-y">
          {(edges || []).map(({ node }) => {
            const {
              id,
              excerpt,
              frontmatter: {
                title,
                category,
                date,
                featured_image: { thumbnail },
              },
              fields: { slug },
            } = node;

            return (
              <BlogPostCard
                key={id}
                title={title}
                thumbnail={thumbnail}
                slug={slug}
                excerpt={excerpt}
                date={date}
                category={category}
              />
            );
          })}
        </ul>
      </Article>
    </Layout>
  );
};

export const postsQuery = graphql`
  query BlogPostsQuery {
    allMdx(
      sort: { order: DESC, fields: frontmatter___date }
      filter: { fields: { slug: { ne: "privacy-policy" } } }
    ) {
      edges {
        node {
          id
          excerpt
          frontmatter {
            date(formatString: "MMM DD, YYYY")
            title
            category
            featured_image {
              thumbnail: img {
                childImageSharp {
                  fluid(maxWidth: 650, quality: 90) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;

export default PostsPage;
